var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-hostess-tasks", class: [_vm.packageName] },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top: ${_vm.barHeight}px;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("lang.host.hostessTasks")) + " "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _vm.wholeTaskTimeSeconds
                      ? _c("div", { staticClass: "tit-right" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/packageAssets/views/P1_Girls/HostessTasks/vava/clock1.png"),
                              alt: "",
                            },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.transformSeconds1(_vm.wholeTaskTimeSeconds)
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("TopTime", {
        attrs: { onlineTime: _vm.onlineTime, callTime: _vm.callTime },
      }),
      _vm.packageName === "kiko"
        ? _c(
            "div",
            { staticClass: "main-content" },
            [
              _vm.newerTask && _vm.newerTask.length > 0
                ? _c("NewTasksKiko", {
                    attrs: {
                      newerTask: _vm.newerTask,
                      dailyTask: _vm.dailyTask,
                      newerTaskTimeSeconds: _vm.newerTaskTimeSeconds,
                    },
                  })
                : _vm._e(),
              _vm.dailyTask && _vm.dailyTask.length > 0
                ? _c("DailyTasksKiko", {
                    attrs: {
                      newerTask: _vm.newerTask,
                      dailyTask: _vm.dailyTask,
                      weekTask: _vm.weekTask,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "main-content" },
            [
              _vm.newerTask && _vm.newerTask.length > 0
                ? _c("NewTasks", {
                    attrs: {
                      newerTask: _vm.newerTask,
                      dailyTask: _vm.dailyTask,
                      newerTaskTimeSeconds: _vm.newerTaskTimeSeconds,
                    },
                  })
                : _vm._e(),
              _vm.dailyTask && _vm.dailyTask.length > 0
                ? _c("DailyTasks", {
                    attrs: {
                      newerTask: _vm.newerTask,
                      dailyTask: _vm.dailyTask,
                      weekTask: _vm.weekTask,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }